import "./skills.css";
import HTML from "../../assets/images/HTML.svg.png";
import CSS from "../../assets/images/CSS3_logo.svg.png";
import JS from "../../assets/images/JS.png";
import TS from "../../assets/images/TS.png";
import React from "../../assets/images/React-icon.svg.png";
import Redux from "../../assets/images/redux.png";
import ReactNative from "../../assets/images/ReactNative.jpg";
import Next from "../../assets/images/next.png";
import Node from "../../assets/images/node.png";
import Express from "../../assets/images/express.png";
import Postgre from "../../assets/images/postgreSQL.png";
import MySQl from "../../assets/images/mysql.png";
import Sequelize from "../../assets/images/sequelize.png";
import Primsa from "../../assets/images/prisma.png";
import Tailwind from "../../assets/images/tailwind.png";
import Bootstrap from "../../assets/images/bootstrap.png";
import SASS from "../../assets/images/sass.png";
import Git from "../../assets/images/git.png";
import Github from "../../assets/images/github.png";
import Figma from "../../assets/images/figma.png";
import Pyhton from "../../assets/images/python.png";
import Photoshop from "../../assets/images/photoshop.png";
import Scrum from "../../assets/images/scrum.png";
import SEO from "../../assets/images/SEO.png";
import SQLite from "../../assets/images/sqlite.png";
import Postman from "../../assets/images/postman.png";
import Jest from "../../assets/images/jest.png";
import JQuery from "../../assets/images/JQuery.png";
import Angular from "../../assets/images/Angular.png";
import Vue from "../../assets/images/Vue.png";
import PHP from "../../assets/images/php.png";
import Csharp from "../../assets/images/Csharp.png";
import Wordpress from "../../assets/images/Wordpress.png";
import Shopify from "../../assets/images/shopify.png";
import Mongodb from "../../assets/images/Mongodb.png";

export default function Skills() {
  return (
    <div className="bigSkillsContainer">
      <div className="skillsTextContainer animate__animated animate__fadeInLeft">
        <h2>Skills</h2>
      </div>
      <div className="skillsContainer animate__animated animate__backInUp">
        <a
          href="https://developer.mozilla.org/en-US/docs/Web/HTML"
          className="skillsIconsContainer"
          target="_blank"
          rel="noreferrer"
        >
          <img src={HTML} alt="HTML Logo" className="skillsIcons" />
          <p>HTML</p>
        </a>
        <a
          href="https://developer.mozilla.org/en-US/docs/Web/CSS"
          className="skillsIconsContainer"
          target="_blank"
          rel="noreferrer"
        >
          <img src={CSS} alt="CSS Logo" className="skillsIcons" />
          <p>CSS</p>
        </a>
        <a
          href="https://jquery.com"
          className="skillsIconsContainer"
          target="_blank"
          rel="noreferrer"
        >
          <img src={JQuery} alt="JQuery Logo" className="skillsIcons" />
          <p>JQuery</p>
        </a>
        <a
          href="https://www.javascript.com/about"
          className="skillsIconsContainer"
          target="_blank"
          rel="noreferrer"
        >
          <img src={JS} alt="JavaScript Logo" className="skillsIcons" />
          <p>JavaScript</p>
        </a>
        <a
          href="https://www.typescriptlang.org"
          className="skillsIconsContainer"
          target="_blank"
          rel="noreferrer"
        >
          <img src={TS} alt="TypeScript Logo" className="skillsIcons" />
          <p>TypeScript</p>
        </a>
        <a
          href="https://reactjs.org"
          className="skillsIconsContainer"
          target="_blank"
          rel="noreferrer"
        >
          <img src={React} alt="React Logo" className="skillsIcons" />
          <p>React</p>
        </a>
        <a
          href="https://redux.js.org"
          className="skillsIconsContainer"
          target="_blank"
          rel="noreferrer"
        >
          <img src={Redux} alt="Redux Logo" className="skillsIcons" />
          <p>Redux</p>
        </a>
        <a
          href="https://reactnative.dev"
          className="skillsIconsContainer"
          target="_blank"
          rel="noreferrer"
        >
          <img src={ReactNative} alt="React Native Logo" className="skillsIcons" />
          <p>React Native</p>
        </a>
        <a
          href="https://angular.io"
          className="skillsIconsContainer"
          target="_blank"
          rel="noreferrer"
        >
          <img src={Angular} alt="Angular Logo" className="skillsIcons" />
          <p>Angular</p>
        </a>
        <a
          href="https://vuejs.org"
          className="skillsIconsContainer"
          target="_blank"
          rel="noreferrer"
        >
          <img src={Vue} alt="Vue Logo" className="skillsIcons" />
          <p>Vue</p>
        </a>
        <a
          href="https://www.python.org"
          className="skillsIconsContainer"
          target="_blank"
          rel="noreferrer"
        >
          <img src={Pyhton} alt="Python Logo" className="skillsIcons" />
          <p>Python</p>
        </a>
        <a
          href="https://learn.microsoft.com/en-us/dotnet/csharp"
          className="skillsIconsContainer"
          target="_blank"
          rel="noreferrer"
        >
          <img src={Csharp} alt="C# Logo" className="skillsIcons" />
          <p>C#</p>
        </a>
        <a href="https://www.php.net" className="skillsIconsContainer" target="_blank" rel="noreferrer">
            <img src={PHP} alt="PHP Logo" className="skillsIcons" />
            <p>PHP</p>
          </a>
        <a
          href="https://nodejs.org/en/about/"
          className="skillsIconsContainer"
          target="_blank"
          rel="noreferrer"
        >
          <img src={Node} alt="Nodejs Logo" className="skillsIcons" />
          <p>Node.js</p>
        </a>
        <a
          href="https://nextjs.org"
          className="skillsIconsContainer"
          target="_blank"
          rel="noreferrer"
        >
          <img src={Next} alt="Nextjs Logo" className="skillsIcons" />
          <p>Next.js</p>
        </a>
        <a
          href="https://expressjs.com"
          className="skillsIconsContainer"
          target="_blank"
          rel="noreferrer"
        >
          <img src={Express} alt="Express Logo" className="skillsIcons" />
          <p>Express</p>
        </a>
        <a
          href="https://wordpress.com"
          className="skillsIconsContainer"
          target="_blank"
          rel="noreferrer"
        >
          <img src={Wordpress} alt="Wordpress Logo" className="skillsIcons" />
          <p>Wordpress</p>
        </a>
        <a
          href="https://www.shopify.com"
          className="skillsIconsContainer"
          target="_blank"
          rel="noreferrer"
        >
          <img src={Shopify} alt="Shopify Logo" className="skillsIcons" />
          <p>Shopify</p>
        </a>
        <a
          href="https://sequelize.org"
          className="skillsIconsContainer"
          target="_blank"
          rel="noreferrer"
        >
          <img src={Sequelize} alt="Sequelize Logo" className="skillsIcons" />
          <p>Sequelize</p>
        </a>
        <a
          href="https://www.postgresql.org/about/"
          className="skillsIconsContainer"
          target="_blank"
          rel="noreferrer"
        >
          <img src={Postgre} alt="PostgreSQL Logo" className="skillsIcons" />
          <p>PostgreSQL</p>
        </a>
        <a
          href="https://www.mysql.com"
          className="skillsIconsContainer"
          target="_blank"
          rel="noreferrer"
        >
          <img src={MySQl} alt="MySQl Logo" className="skillsIcons" />
          <p>MySQl</p>
        </a>
        <a
          href="https://sqlite.org/index.html"
          className="skillsIconsContainer"
          target="_blank"
          rel="noreferrer"
        >
          <img src={SQLite} alt="SQLite Logo" className="skillsIcons" />
          <p>SQLite</p>
        </a>
        <a
          href="https://www.mongodb.com"
          className="skillsIconsContainer"
          target="_blank"
          rel="noreferrer"
        >
          <img src={Mongodb} alt="Mongodb Logo" className="skillsIcons" />
          <p>Mongodb</p>
        </a>
        <a
          href="https://www.prisma.io"
          className="skillsIconsContainer"
          target="_blank"
          rel="noreferrer"
        >
          <img src={Primsa} alt="Primsa Logo" className="skillsIcons" />
          <p>Primsa</p>
        </a>
        <a
          href="https://tailwindcss.com"
          className="skillsIconsContainer"
          target="_blank"
          rel="noreferrer"
        >
          <img src={Tailwind} alt="Tailwind Logo" className="skillsIcons" />
          <p>Tailwind</p>
        </a>
        <a
          href="https://getbootstrap.com"
          className="skillsIconsContainer"
          target="_blank"
          rel="noreferrer"
        >
          <img src={Bootstrap} alt="Bootstrap Logo" className="skillsIcons" />
          <p>Bootstrap</p>
        </a>
        <a
          href="https://sass-lang.com"
          className="skillsIconsContainer"
          target="_blank"
          rel="noreferrer"
        >
          <img src={SASS} alt="SASS Logo" className="skillsIcons" />
          <p>SASS</p>
        </a>
        <a
          href="https://jestjs.io"
          className="skillsIconsContainer"
          target="_blank"
          rel="noreferrer"
        >
          <img src={Jest} alt="Jest Logo" className="skillsIcons" />
          <p>Jest</p>
        </a>
        <a
          href="https://developer.mozilla.org/es/docs/Glossary/SEO"
          className="skillsIconsContainer"
          target="_blank"
          rel="noreferrer"
        >
          <img src={SEO} alt="SEO Image" className="skillsIcons" />
          <p>SEO</p>
        </a>
        <a
          href="https://git-scm.com"
          className="skillsIconsContainer"
          target="_blank"
          rel="noreferrer"
        >
          <img src={Git} alt="Git Logo" className="skillsIcons" />
          <p>Git</p>
        </a>
        <a
          href="https://github.com/about"
          className="skillsIconsContainer"
          target="_blank"
          rel="noreferrer"
        >
          <img src={Github} alt="GitHub Logo" className="skillsIcons" />
          <p>GitHub</p>
        </a>
        <a
          href="https://www.scrum.org"
          className="skillsIconsContainer"
          target="_blank"
          rel="noreferrer"
        >
          <img src={Scrum} alt="Scrum" className="skillsIcons" />
          <p>Scrum</p>
        </a>
        <a
          href="https://www.postman.com"
          className="skillsIconsContainer"
          target="_blank"
          rel="noreferrer"
        >
          <img src={Postman} alt="Postman Logo" className="skillsIcons" />
          <p>Postman</p>
        </a>
        <a
          href="https://www.figma.com"
          className="skillsIconsContainer"
          target="_blank"
          rel="noreferrer"
        >
          <img src={Figma} alt="Figma Logo" className="skillsIcons" />
          <p>Figma</p>
        </a>
        <a
          href="https://helpx.adobe.com/support/photoshop.html"
          className="skillsIconsContainer"
          target="_blank"
          rel="noreferrer"
        >
          <img src={Photoshop} alt="Photoshop Logo" className="skillsIcons" />
          <p>Photoshop</p>
        </a>
      </div>
    </div>
  );
}
